<template>
  <div class="content-page">
    <!-- Hero -->
    <section class="landing-hero">
      <div class="landing-hero__content">
        <h1 class="landing-hero__title">{{ page.hero.title }}</h1>
        <p class="landing-hero__subline">{{ page.hero.subline }}</p>
        <div class="landing-hero__actions">
          <component
            v-for="action in page.hero.actions"
            :key="action.label"
            :is="heroActionComponent(action)"
            v-bind="heroActionBindings(action)"
            class="button"
            :class="action.primary ? 'button--primary' : 'button--ghost'"
          >
            {{ action.label }}
          </component>
        </div>
      </div>
    </section>

    <!-- Pillars: three value panels -->
    <PageSection
      :label="page.pillars.label"
      :heading="page.pillars.heading"
    >
      <div class="shift-panels">
        <article
          v-for="panel in page.pillars.panels"
          :key="panel.title"
          class="shift-panel"
        >
          <h3 class="shift-panel__question">{{ panel.title }}</h3>
          <p class="shift-panel__answer">{{ panel.copy }}</p>
          <ImageLightbox :src="panel.screenshot.src" :alt="panel.screenshot.alt" />
        </article>
      </div>
    </PageSection>

    <!-- How It Works -->
    <PageSection
      id="how-it-works"
      :label="page.howItWorks.label"
      :heading="page.howItWorks.heading"
    >
      <div class="steps-grid">
        <article
          v-for="step in page.howItWorks.steps"
          :key="step.number"
          class="step-card"
        >
          <span class="step-card__number">{{ step.number }}</span>
          <h3 class="step-card__title">{{ step.title }}</h3>
          <p class="step-card__copy">{{ step.copy }}</p>
          <ImageLightbox :src="step.screenshot.src" :alt="step.screenshot.alt" />
        </article>
      </div>
    </PageSection>

    <!-- Learning Signals strip ("Show me") -->
    <PageSection
      :label="page.learningSignals.label"
      :heading="page.learningSignals.heading"
    >
      <div class="learning-signals">
        <p class="learning-signals__copy">{{ page.learningSignals.copy }}</p>
        <ImageLightbox
          :src="page.learningSignals.screenshot.src"
          :alt="page.learningSignals.screenshot.alt"
        />
      </div>
    </PageSection>

    <!-- Close -->
    <section class="landing-close">
      <div class="landing-close__thesis">
        <p
          v-for="line in page.close.thesis"
          :key="line"
          class="landing-close__thesis-line"
        >
          {{ line }}
        </p>
      </div>
      <div class="landing-close__actions">
        <router-link
          v-for="action in page.close.actions"
          :key="action.label"
          :to="action.to"
          class="button"
          :class="action.primary ? 'button--primary' : 'button--ghost'"
        >
          {{ action.label }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script setup>
import PageSection from '@/components/PageSection.vue'
import ImageLightbox from '@/components/ImageLightbox.vue'
import { overviewPage as page } from '@/config/overview'

function isPageAnchorAction(action) {
  return typeof action.to === 'string' && action.to.startsWith('#')
}

function heroActionComponent(action) {
  if (isPageAnchorAction(action)) return 'a'
  return action.to ? 'router-link' : 'a'
}

function heroActionBindings(action) {
  if (isPageAnchorAction(action)) return { href: action.to }
  return action.to ? { to: action.to } : { href: action.href }
}
</script>
